<template>
  <div class="benefits">
    <div class="benefits__container">
      <h2>{{ displayTitle }}</h2>
      <p>{{ displayDescription }}</p>
      <div class="benefits__body">
        <div class="benefits__list">
          <div class="benefit__item" v-for="(benefit, i) in displayBenefits.filter((item, index) => index < 3 || showMore)" :key="i" :class="['benefit__item--' + i]">
            <img v-if="benefitIcons[i]" :src="benefitIcons[i]" alt="" loading="lazy" decoding="async">
            <h3>{{benefit.title}}</h3>
            <p v-html="benefit.description"></p>
          </div>
        </div>
        <a v-if="!showMore && displayBenefits.length > 3" @click="switchShowMore">{{$t('showAllFunctionality')}}</a>
        <a v-else-if="showMore && displayBenefits.length > 3" @click="switchShowMore">{{$t('hideAllFunctionality')}}</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    benefitIcons: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    benefits: {
      type: Array,
      default: () => []
    }
  },
  data(){
    return {
      showMore: false
    }
  },
  computed: {
    displayTitle() {
      return this.title || this.$t("benefitTitle");
    },
    displayDescription() {
      return this.description || this.$t("benefitDescription");
    },
    displayBenefits() {
      if (this.benefits.length > 0) return this.benefits;
      
      return [
        {
          title: this.$t('benefitTitle1'),
          description: this.$t('benefitDescription1')
        },
        {
          title: this.$t('benefitTitle2'),
          description: this.$t('benefitDescription2')
        },
        {
          title: this.$t('benefitTitle3'),
          description: this.$t('benefitDescription3')
        },
        {
          title: this.$t('benefitTitle4'),
          description: this.$t('benefitDescription4')
        },
        {
          title: this.$t('benefitTitle5'),
          description: this.$t('benefitDescription5')
        },
        {
          title: this.$t('benefitTitle6'),
          description: this.$t('benefitDescription6')
        }
      ];
    }
  },
  methods: {
    switchShowMore(){
      this.showMore = !this.showMore
    }
  }
}
</script>

<style lang="scss" scoped>
.benefits {
  padding-top: 50px;
  padding-bottom: 50px;
  background-image: linear-gradient(to top, rgba(42, 138, 234, 0), rgba(42, 138, 234, .2));

  @media (max-width: 767px) {
    display: none;
  }
}

.benefits__container {
  width: 1010px;
  margin: 0 auto;

  & > h2 {
    font-size: 31px;
    font-weight: bold;
    text-align: center;
    color: rgb(27, 39, 51);
  }

  & > p {
    margin-top: 12px;
    margin-bottom: 50px;
    font-size: 14px;
    text-align: center;
    color: rgb(27, 39, 51);
    white-space: break-spaces;
    line-height: 22px;
  }

  @media (max-width: 1024px) {
    width: 720px;
  }
}

.benefits__body {
  text-align: center;
  & > a {
    font-size: 13px;
    font-weight: bold;
    letter-spacing: 0.6px;
    color: #2a8aea;
    text-transform: uppercase;
    cursor: pointer;
    opacity: .8;
    text-decoration: none;
    display: inline-block;

    &:hover, &:active {
      opacity: 1;
    }
  }
}

.benefits__list {
  text-align: left;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.benefit__item {
  width: 310px;
  position: relative;
  margin-bottom: 40px;

  ::v-deep(a) {
    color: rgba(42, 138, 234, .85);
    border-bottom: 1px solid rgba(42, 138, 234, .2);
    text-decoration: none;

    &:hover {
      color: #2a8aea;
      border-bottom: 1px solid rgba(42, 138, 234, .4);
    }
  }

  @media (max-width: 1024px) {
    width: 350px;

    &:nth-child(3n) {
      display: none;
    }
  }

  img {
    display: inline-block;
    content: "";
    margin-bottom: 10px;
    width: 42px;
    height: 42px;
    background-size: cover;
  }

  h3 {
    font-size: 16px;
    font-weight: bold;
    color: rgb(27, 39, 51);
  }

  p {
    opacity: 0.9;
    font-size: 14px;
    line-height: 1.57;
    color: rgba(27, 39, 51, .9);
    margin-top: 6px;
  }
}
</style>
